import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in

  useEffect(() => {
    let mounted = true;
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then((r) => mounted && setUser((cur) => cur || r.data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); if (mounted) setUser((cur) => (cur ? cur : false)); });
    return () => { mounted = false; };
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* noop */ }
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
